// ✅ FormInput.jsx
import React from "react";
import PropTypes from "prop-types";

const FormInput = (
  {
    field,
    value,
    handleChange,
    error = null,
    className = "",
    ErrIsScroll = false,
  }) => {
  return (
    <div className={`${className} ${field.fieldSize || "col-12"}`} >
      {!field.lableHide && (
        field.label ? (
          <label className="form-label text-muted">
            {field.label}{" "}
            {field.required && <span className="text-danger small">*</span>}
          </label>
        ) : (
          <label className="mt-sm-4"></label>
        )
      )}

      <input
        type={field.type || "text"}
        className={`form-control ${error ? "border-danger" : ""}`}
        name={field.name}
        value={value}
        onChange={handleChange}
        placeholder={field.placeholder || ""}
        required={field.required || false}
        disabled={field.disabled || false}
        readOnly={field.readOnly || false}
        min={field.min || 0}
        minLength={field.minLength || 0}
        max={field.max || Infinity}
        maxLength={field.maxLength || Infinity}
        accept={field.accept || ""}
        step={field.step || ""}
      />

      {error && ErrIsScroll && <span className="text-danger overflow-y-scroll w-100 d-block" style={{ "height": "30px" }}>{error}</span>}
      {error && !ErrIsScroll && <span className="text-danger">{error}</span>}
    </div>
  );
};

FormInput.propTypes = {
  value: PropTypes.any,
  handleChange: PropTypes.func,
  error: PropTypes.any,
  className: PropTypes.string,
  field: PropTypes.object,
};

export default FormInput;